<template>
  <div
    id="mapConEstimating"
    ref="mapConEstimating"
    style=""
  >
    <v-menu
      v-model="routeSettingPopVisible"
      :close-on-content-click="false"
      :position-x="popPositionX"
      :position-y="popPositionY"
      max-width="300"
      absolute
      offset-y
      offset-x
    >
      <v-card elevation="1">
        <div
          class="px-2 py-3 grey lighten-2 d-flex align-center justify-space-between"
          dense
        >
          <div class="text-caption font-weight-bold">
            {{ wayPointName }}
          </div>
          <v-btn
            icon
            @click="routeSettingPopVisible = false"
            x-small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-3">
          <v-row dense>
            <v-select
              :items="routeTypeArr"
              :label="$t('m.routingPointStatus')"
              outlined
              dense
              hide-details="true"
              v-model="wayPointState"
              item-text="text"
              item-value="val"
            />
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-select
              :items="portPointArrSelect
                .filter(ele => ele.PortID!==wayPointRoutePointId)"
              label="Prev Port"
              outlined
              dense
              hide-details="true"
              :disabled="wayPointState!==1 || portPointArr.length==0"
              v-model="wayPointPositionPortID"
              item-text="PortName"
              item-value="PortID"
            />
          </v-row>
        </div>
      </v-card>
    </v-menu>

    <TurningEditMenu
      :visible="turningEditVisible"
      :is-turning-edit="isTurningEdit"
      :position-x="turningEditPopPositionX"
      :position-y="turningEditPopPositionY"
      :longitude="longitude"
      :latitude="latitude"
      @cancel="cancelTurningEditMenu"
      @addTurnPoint="addTurnPoint"
      @updateTurnPoint="updateTurnPoint"
      @removeTurnPoint="removeTurnPoint"
    />

    <v-snackbar
      v-model="snackbar"
      app
      absolute
      bottom
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('m.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as esriLoader from 'esri-loader'
import { mapState, mapGetters } from 'vuex'
import ECAUtil from '@/utils/ecaUtil'
import MapUtil from '@/utils/mapUtil'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import API from '@/api/api'
import Constant from '@/constant'
import TurningEditMenu from '@/components/TurningEditMenu'

const markerSymbol = {
  type: 'simple-marker',
  color: [150, 0, 0, 0.7],
  size: 4,
  outline: {
    width: 1,
    color: [150, 0, 0, 0.5]
  }
}
const lineSymbol = {
  type: 'simple-line',
  color: [161, 68, 59, 1],
  width: 1.3,
  style: 'solid'
}
const ecalineSymbol = {
  type: 'simple-line',
  color: 'green',
  width: 1.3,
  style: 'solid'
}

export default {
  name: 'MapView',
  props: [
    'timing', 'estiID'
  ],
  components: {
    TurningEditMenu
  },
  data () {
    return {
      isLoading: false,
      finishedMakePointArr: false,

      map: null,
      mapView: null,
      Graphic: null,
      GraphicsLayer: null,
      webMercatorUtils: null,
      portPointLayer: null, // 港口图层
      routePointsLayer: null, // 路由点图像层
      trackLayer: null, // 航线图层
      trackLines: [], // 航线轨迹
      ecaAreaLayer: null, // ECA区域图层
      ecaLineLayer: null, // ECA区域边线图层
      ecaLines: [],
      ecaAreas: [],

      turnPointsLayer: null,
      turnGraphics: [], // 转向点图像
      turningEditVisible: false,
      isTurningEdit: false, // 是否是修改状态
      turningEditTab: null,
      labelGraphic: null,
      bgGraphic: null,
      turningHighlightSelect: false,
      turningEditPopPositionX: 0,
      turningEditPopPositionY: 0,
      longitude: '',
      latitude: '',

      sketchVM: null,
      turnId: -1,
      duringLine1: null,
      duringLine2: null,
      focusGraphic: null,

      routePointsGraphics: [], // 路由点图像
      routeSettingPopVisible: false,
      popPositionX: 0,
      popPositionY: 0,
      routeTypeArr: [{
        val: MapUtil.WAYPOINT_TYPE_EXC,
        text: this.$t('m.pointOptionExc')
      },
      {
        val: MapUtil.WAYPOINT_TYPE_DEFAULT,
        text: this.$t('m.pointOptionDefault')
      },
      {
        val: MapUtil.WAYPOINT_TYPE_REQUIRED,
        text: this.$t('m.pointOptionRequired')
      }
      ],

      selRouteFeature: null, // 选择的路由点Feature ROUTEPOINTID
      wayPointRoutePointId: null, // 当前点的 RoutePoint
      wayPointName: '',
      wayPointState: MapUtil.WAYPOINT_TYPE_DEFAULT,
      wayPointPositionPortID: '',

      snackbar: false,
      snackbarText: null,
      progressCount: 0
    }
  },
  computed: {
    ...mapState({
      isGettedDistance: state => state.estiDistance.isGettedDistance,
      isGettedDistanceFail: state => state.estiDistance.isGettedDistanceFail,
      finishedTrack: state => state.estiDistance.finishedTrack,
      resetEstiMap: state => state.estiDistance.resetEstiMap,

      trackVisible: state => state.estiDistance.trackVisible,
      turnLayerVisible: state => state.estiDistance.turnLayerVisible,
      turningPoints: state => state.estiDistance.turningPoints,

      routePorts: state => state.estiDistance.routePorts,
      isNeedCalAfterRebuild: state => state.estiDistance.isNeedCalAfterRebuild,
      originRoutes: state => state.estiDistance.originRoutes,
      portPointArr: state => state.estiDistance.portPointArr,
      originPortPointArr: state => state.estiDistance.originPortPointArr,

      resetWayPointFlag: (state) => state.estiDistance.resetWayPointFlag,
      routeLayerVisible: (state) => state.estiDistance.routeLayerVisible,
      requiredWayPointArr: (state) => state.estiDistance.requiredWayPointArr,
      originRequiredWayPointArr: (state) => state.estiDistance.originRequiredWayPointArr,

      routes: state => state.route.routes
    }),

    mapLoaded () {
      return this.judgeMapLoaded()
    },

    portPointArrSelect () {
      return this.portPointArr.slice(0, this.portPointArr.length - 1)
    },

    portIdStr () {
      var portIdArr = []
      this.portPointArr.forEach((ele, index) => {
        portIdArr.push(ele.PortID)
      })
      return portIdArr.join(',')
    }

  },
  watch: {
    mapLoaded: function (val) {
      val && this.initialize()
    },

    timing: function (val) {
      if (val && this.mapLoaded) {
        this.initialize()
      }
    },

    isGettedDistance: function (val) {
      if (val && this.finishedTrack) {
        this.resetTrackLayer()
        this.makeTrack()
      }
    },

    routeLayerVisible: { // 控制路由层的显示
      handler (val) {
        if (!this.routePointsLayer) { this.createRoutePointsLayer(this.routePointsGraphics) } else {
          this.routePointsLayer.visible = val
        }
      }
    },

    routeSettingPopVisible: function (val) {
      if (val === true) {
        const existIndex = this.portPointArr
          .findIndex(ele => ele.PortID === this.wayPointRoutePointId)
        if (existIndex != -1) { this.wayPointPositionPortID = this.portPointArr[existIndex - 1].PortID }
      }
    },

    wayPointState: function (val) {
      // console.log(this.selRouteFeature);
      var currPortID = this.selRouteFeature.attributes.rpId
      if ((val - 0) != MapUtil.WAYPOINT_TYPE_REQUIRED) {
        // 判断是否要从必须中移除
        this.$store.commit('removeRequiredWayPointEsti', {
          PortID: currPortID
        })

        // 删除 from portPointArr
        this.$store.commit('removeRequiredWayPointFromPortPointArrEsti', {
          PortID: currPortID
        })

        // 更新排除路由点的数组
        this.$store.commit('updateExcWayPointArrEsti', {
          waypointID: this.selRouteFeature.attributes.ObjectID,
          option: val
        })

        this.wayPointPositionPortID = ''
        this.setRouteFeatureAttribute(this.selRouteFeature, val)
      } else { // 必须经过
        const existIndex = this.portPointArr
          .findIndex(ele => ele.PortID === currPortID)

        if (existIndex === -1) { // 新加的必须 默认是 0 需要重新计算
          this.wayPointPositionPortID = ''
        } else {
          this.wayPointPositionPortID = this.portPointArr[existIndex - 1].PortID
        }
      }
    },

    wayPointPositionPortID: function (val) {
      if (val == '' || !this.selRouteFeature) {
        return
      }

      var newWayPoint = {
        PortID: this.selRouteFeature.attributes.rpId, // 路由点
        PortName: this.selRouteFeature.attributes.rpName,
        isWayPoint: true
      }
      // 新的位置
      const pos = this.portPointArr.findIndex(ele => ele.PortID === val)
      newWayPoint.index = pos + 1

      const index = this.portPointArr
        .findIndex(ele => ele.PortID === this.selRouteFeature.attributes.rpId)

      if (index == -1) { // 新的点
        this.$store.commit('addRequiredWayPointEsti', newWayPoint)
        this.$store.commit('addRequiredWayPointToPortPointArrEsti', newWayPoint)
        this.setRouteFeatureAttribute(this.selRouteFeature, MapUtil.WAYPOINT_TYPE_REQUIRED)
      } else {
        this.$store.commit('removeRequiredWayPointFromPortPointArrEsti', {
          PortID: newWayPoint.PortID
        })
        this.$store.commit('addRequiredWayPointToPortPointArrEsti', newWayPoint)
      }
    },

    resetWayPointFlag: function (val) { // rpId
      if (!val) return
      this.$store.commit('resetWayPointArrEsti')
      this.$store.commit('setPortPointArrEsti', _.cloneDeep(this.originPortPointArr))

      const routeQuery = this.routePointsLayer.createQuery()
      const arr = this.$store.state.route.excWayPointArr
      this.routePointsLayer.queryFeatures(routeQuery).then((results) => {
        if (results.features.length > 0) {
          results.features.forEach((v) => {
            if (this.originRequiredWayPointArr
              .findIndex(ele => ele.PortID === v.attributes.rpId) !== -1) {
              this.setRouteFeatureAttribute(v, MapUtil.WAYPOINT_TYPE_REQUIRED)
            } else if (v.attributes.option !== MapUtil.WAYPOINT_TYPE_DEFAULT &&
                  !arr.includes(v.attributes.ObjectID)) {
              this.setRouteFeatureAttribute(v, MapUtil.WAYPOINT_TYPE_DEFAULT)
            }
          })
        }
      })

      this.$store.commit('setResetWayPointFlagEsti', false)
    }, // end resetWayPointFlag

    turnLayerVisible: function (val) {
      if (!this.turnPointsLayer) this.createTurningLayer()
      if (val) {
        this.showTurning(this.turningPoints)
      } else {
        this.removeTurnGraphics()
      }
    },

    resetEstiMap: function (val) {
      console.log(val)
      if (val) {
        this.resetPortLayer()
        this.resetTrackLayer()
        this.resetRoutePointDefaultOption()
      }
    },

    finishedMakePointArr: function (val) {
      if (val) {
        this.$emit('drawed')
      }
    }

  },
  methods: {
    POST (url, params) {
      return new Promise((resolve, reject) => {
        httpClient.post(url, params)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    initialize () {
      if (this.finishedTrack) { // 已经绘制完成
        return
      }

      if (this.routePorts.length > 0) { // 已发生完整计算
        this.resetPortLayer()
        this.resetTrackLayer()

        this.makePortPointArr()
        this.makeTrack()
      } else { // 用于预算修改并没有发生计算时
        this.resetPortLayer()
        this.resetTrackLayer()

        this.makePortPointArr()
        var portIdStr = this.portIdStr
        // this.$store.commit("setIsCalculating", true)
        this.$store.dispatch('getDistanceForEsti', { portIdStr: portIdStr }).then(() => {
          this.makeTrack()
        })
      }
    },

    // 引入并创建地图
    createMap () {
      const options = {
        version: '4.16',
        css: true
      }
      // 创建地图
      esriLoader
        .loadModules(
          [
            'esri/Map',
            'esri/views/MapView',
            'esri/Graphic',
            'esri/core/watchUtils',
            'esri/geometry/support/webMercatorUtils',
            'esri/layers/GraphicsLayer'
          ],
          options
        )
        .then(([Map, MapView, Graphic, watchUtils, webMercatorUtils, GraphicsLayer]) => {
          this.map = new Map({
            basemap: 'oceans'
          })
          this.Graphic = Graphic
          this.webMercatorUtils = webMercatorUtils
          this.GraphicsLayer = GraphicsLayer
          this.mapView = new MapView({
            map: this.map,
            container: 'mapConEstimating',
            center: [122, 32],
            spatialReference: {
              wkid: 102100
            },
            zoom: 3,
            constraints: {
              minZoom: 1,
              maxZoom: 16,
              snapToZoom: false,
              rotationEnabled: false
            },
            popup: {
              dockEnabled: true,
              dockOptions: {
                buttonEnabled: false,
                breakpoint: false
              }
            }
          })

          this.mapView.ui.remove('zoom') // 缩放控件放右下脚
          this.mapView.ui.remove('attribution') // 移除地图描述
          this.createECALayer()
          this.trackLayer = new GraphicsLayer({
            id: 'track-layer'
          })
          this.map.add(this.trackLayer)

          // 获取路由点信息并构建其Graphics
          this.createRoutePointsGraphics()

          // 转向点图层
          this.turnPointsLayer = new GraphicsLayer({
            id: 'turn-layer'
          })
          this.map.add(this.turnPointsLayer)

          this.createPortLayer()
          this.createMapViewEvent()
          watchUtils.init(this.mapView, 'zoom', (v) => {
            if (this.routePointsLayer) {
              this.routePointsLayer.definitionExpression = 'remark < ' + (v <= 2 ? 2 : v)
            }
          })
        })
        .catch((error) => {
          this.$nextTick(() => {
            // this.loading.close();
          })
        })
    },

    // 创建港口点要素图层
    createPortLayer () {
      esriLoader.loadModules(['esri/layers/FeatureLayer']).then(([FeatureLayer]) => {
        this.portPointLayer = MapUtil.createFeatureLayer(FeatureLayer, { id: 'port-layer' })
        this.map.add(this.portPointLayer)
      })
    },

    // 获取路由点信息并构建其Graphics
    async createRoutePointsGraphics () {
      let myRoutes
      if (this.routes.length == 0) {
        myRoutes = await this.POST('/SPRoutePointQry', {
          OperID: Utils.getWithExpiry('operID')
        })
        this.$store.commit('setRoutes', myRoutes)
      } else {
        myRoutes = this.routes
      }

      // 生成路由点的图像数据
      this.routePointsGraphics = myRoutes.map((r) => {
        let option = MapUtil.WAYPOINT_TYPE_DEFAULT
        if (MapUtil.EXC_WAYPOINT_DEFAULT_ARR.includes(r.WAYPOINTID)) {
          option = MapUtil.WAYPOINT_TYPE_EXC
        }

        if (this.originRequiredWayPointArr.findIndex(ele => ele.PortID === r.ROUTEPOINTID) !== -1) {
          option = MapUtil.WAYPOINT_TYPE_REQUIRED
        }

        return {
          geometry: {
            type: 'point',
            longitude: r.LONGITUDE,
            latitude: r.LATITUDE
          },
          attributes: {
            ObjectID: r.WAYPOINTID,
            rpId: r.ROUTEPOINTID,
            rpName: r.ROUTEPOINTNAME,
            remark: Number(r.REMARK),
            option: option
          }
        }
      })
      this.createRoutePointsLayer(this.routePointsGraphics)
    },

    // 创建路由点要素图层
    createRoutePointsLayer (graphics) {
      esriLoader.loadModules(['esri/layers/FeatureLayer']).then(([FeatureLayer]) => {
        this.routePointsLayer = new FeatureLayer({
          supportsEditing: true,
          supportsAdd: true,
          source: graphics,
          fields: [
            { name: 'ObjectID', alias: 'ObjectID', type: 'oid' },
            { name: 'rpId', alias: 'rpId', type: 'string' },
            { name: 'rpName', alias: 'rpName', type: 'string' },
            { name: 'remark', alias: 'remark', type: 'integer' },
            { name: 'option', alias: 'option', type: 'integer' }
          ],
          objectIdField: 'ObjectID',
          renderer: {
            type: 'unique-value',
            field: 'option',
            uniqueValueInfos: [
              { value: MapUtil.WAYPOINT_TYPE_DEFAULT, symbol: MapUtil.ROUTESYMBOLS[0] },
              { value: MapUtil.WAYPOINT_TYPE_REQUIRED, symbol: MapUtil.ROUTESYMBOLS[1] },
              { value: MapUtil.WAYPOINT_TYPE_EXC, symbol: MapUtil.ROUTESYMBOLS[2] }
            ]
          },
          labelingInfo: {
            labelExpressionInfo: {
              expression: '$feature.rpName'
            },
            symbol: {
              type: 'text',
              color: 'black',
              haloSize: 1,
              haloColor: 'white'
            }
          },
          spatialReference: {
            wkid: 102100
          },
          geometryType: 'point',
          mode: FeatureLayer.MODE_ONDEMAND,
          definitionExpression: 'remark < 4'
        })

        if (!this.routeLayerVisible) { this.routePointsLayer.visible = false }
        //
        this.map.add(this.routePointsLayer)
      })
    },

    createMapViewEvent () { // 地图鼠标点击事件的侦听
      // 地图鼠标移入事件监听
      this.mapView.on('pointer-move', event => {
        this.mapView.hitTest(event).then(response => {
          this.turningHighlightSelect && this.turningHighlightSelect.remove()
          this.mapView.graphics.remove(this.bgGraphic)
          this.mapView.graphics.remove(this.labelGraphic)

          if (response.results.length) {
            let trackGraphic = response.results.filter(result => {
              return result.graphic.layer === this.trackLayer
            })

            if (trackGraphic.length && this.turnLayerVisible) {
              trackGraphic = trackGraphic[0].graphic
              this.mapView.whenLayerView(trackGraphic.layer).then(layerView => {
                this.turningHighlightSelect = layerView.highlight(trackGraphic)
              })
              const text = 'Distance: ' + trackGraphic.attributes.Distance
              const textSymbol = {
                type: 'text',
                text: text,
                color: [67, 67, 67, 1],
                xoffset: 45,
                yoffset: -28,
                font: {
                  size: '10pt',
                  weight: 'lighter'
                }
              }
              const textLength = text.length
              const pmsTextBg = {
                type: 'picture-marker',
                url: require('@/assets/maker.jpg'),
                width: textLength * 5,
                xoffset: 45,
                yoffset: -25
              }
              this.bgGraphic = new this.Graphic({
                geometry: {
                  type: 'point',
                  longitude: response.results[0].mapPoint.longitude,
                  latitude: response.results[0].mapPoint.latitude
                },
                symbol: pmsTextBg
              })
              this.mapView.graphics.add(this.bgGraphic)
              this.labelGraphic = new this.Graphic({
                geometry: {
                  type: 'point',
                  longitude: response.results[0].mapPoint.longitude,
                  latitude: response.results[0].mapPoint.latitude
                },
                symbol: textSymbol
              })
              this.mapView.graphics.add(this.labelGraphic)
            }
          }
        })
      })

      // 地图鼠标双击事件的侦听
      this.mapView.on('double-click', event => {
        event.stopPropagation()
        this.mapView.hitTest(event).then(response => {
          this.clearTurningEdit()
          this.turningEditVisible = false
          this.isTurningEdit = false

          let turnGraphic = response.results.filter(result => {
            return result.graphic.layer === this.turnPointsLayer
          })

          // 转向点
          if (turnGraphic.length && this.turnLayerVisible) {
            this.turningEditPopPositionY = event.y
            this.turningEditPopPositionX = event.x

            turnGraphic = turnGraphic[0].graphic
            this.turnId = turnGraphic.attributes.id
            this.turningEditVisible = true
            this.isTurningEdit = true

            this.longitude = this.numeral(
              response.results[0].mapPoint.longitude
            ).format('0.00000')
            this.latitude = this.numeral(response.results[0].mapPoint.latitude)
              .format('0.00000')
          }
        })
      })

      // 地图鼠标点击事件的侦听
      this.mapView.on('click', event => {
        this.mapView.hitTest(event).then(response => {
          this.clearTurningEdit()
          this.wayPointPositionPortID = ''
          this.turningEditVisible = false
          this.isTurningEdit = false

          let routeGraphic = response.results.filter(result => {
            return result.graphic.layer === this.routePointsLayer
          })
          let trackGraphic = response.results.filter(result => {
            return result.graphic.layer === this.trackLayer
          })
          const turnGraphic = response.results.filter(result => {
            return result.graphic.layer === this.turnPointsLayer
          })
          // 路由点
          if (routeGraphic.length && this.routeLayerVisible) {
            this.popPositionY = event.screenPoint.y
            this.popPositionX = event.screenPoint.x
            routeGraphic = routeGraphic[0].graphic
            if (routeGraphic.attributes) {
              // 是路由点
              this.onClickRoutePoint(routeGraphic)
            }
          }

          // 航线
          if (!turnGraphic.length && trackGraphic.length && this.turnLayerVisible) {
            this.turningEditPopPositionY = event.screenPoint.y
            this.turningEditPopPositionX = event.screenPoint.x
            trackGraphic = trackGraphic[0].graphic
            this.turnId = trackGraphic.attributes.idArr[0]
            this.turningEditVisible = true
            this.turningEditTab = 'turning-tab-1'
            this.isTurningEdit = false

            this.longitude = this.numeral(
              response.results[0].mapPoint.longitude
            ).format('0.00000')

            this.latitude = this.numeral(response.results[0].mapPoint.latitude)
              .format('0.00000')
          }
        })
      })

      // 地图鼠标拖拽事件的侦听
      this.mapView.on('drag', event => {
        this.mapView.hitTest(event).then(response => {
          const turnGraphic = response.results.filter(result => {
            return result.graphic.layer === this.turnPointsLayer
          })
          if (this.routeLayerVisible || this.turnLayerVisible) {
            this.turningEditVisible && this.sketchVM && this.sketchVM.complete()
            this.turningEditVisible = false
          }
        })
      })

      // 地图鼠标滚轮滚动事件的侦听
      this.mapView.on('mouse-wheel', event => {
        if (this.routeLayerVisible || this.turnLayerVisible) {
          this.turningEditVisible && this.sketchVM && this.sketchVM.complete()
          this.turningEditVisible = false
        }
      })

      this.mapView.on('pointer-move', (event) => {
        // this.$store.commit("setMapCurrentPoint", this.mapView.toMap({ x: event.x, y: event.y }))
      })
    }, // end createMapViewEvent

    clearTurningEdit () {
      this.turningEditTab = 'turning-tab-1'
      this.longitude = ''
      this.latitude = ''

      this.lon_D = ''
      this.lon_M = ''
      this.lon_S = ''
      this.lon_A = 'N'

      this.lat_D = ''
      this.lat_M = ''
      this.lat_S = ''
      this.lat_A = 'E'
    },

    onClickRoutePoint (graphic) {
      const routeQuery = this.routePointsLayer.createQuery()
      routeQuery.where = this.routePointsLayer.objectIdField + '=' + graphic.attributes.ObjectID

      this.routePointsLayer.queryFeatures(routeQuery).then((results) => {
        if (results.features.length) {
          this.selRouteFeature = results.features[0].attributes.rpId ? results.features[0] : graphic
          this.wayPointName = this.selRouteFeature.attributes.rpName
          this.wayPointState = this.selRouteFeature.attributes.option
          this.wayPointRoutePointId = this.selRouteFeature.attributes.rpId

          this.routeSettingPopVisible = true
        }
      })
    },

    setRouteFeatureAttribute (newFeature, option) {
      newFeature.setAttribute('option', option)
      this.routePointsLayer.applyEdits({
        updateFeatures: [newFeature]
      })
    },

    // 创建ECA图层
    createECALayer () {
      let linePath = []
      let areaPath = []
      if (!this.ecaAreaLayer) {
        this.ecaAreaLayer = new this.GraphicsLayer({
          id: 'eca-area-layer',
          visible: false
        })
        this.ecaLineLayer = new this.GraphicsLayer({
          id: 'eca-line-layer'
        })
        const ecaLinesList = this.$store.state.distance.ecaLines
        for (let i = 0; i < ecaLinesList.length; i++) {
          linePath = ecaLinesList[i]
          const ecaPolyGrapgic = new this.Graphic({
            geometry: {
              type: 'polyline',
              paths: linePath,
              spatialReference: {
                wkid: 102100
              }
            },
            symbol: {
              type: 'simple-line',
              color: 'green',
              style: 'dash'
            }
          })
          this.ecaLines.push(ecaPolyGrapgic)
        }
        this.mapView.graphics.addMany(this.ecaLines)
        // this.map.add(this.ecaLineLayer)

        const ecaAreaList = this.$store.state.distance.ecaAreas
        for (let i = 0; i < ecaAreaList.length; i++) {
          areaPath = ecaAreaList[i]
          const ecaAreaGrapgic = new this.Graphic({
            geometry: {
              type: 'polygon',
              rings: areaPath,
              spatialReference: {
                wkid: 102100
              }
            },
            symbol: {
              type: 'simple-fill',
              color: [227, 139, 79, 0.8],
              outline: {
                color: [255, 255, 255],
                width: 1
              }
            }
          })
          this.ecaAreas.push(ecaAreaGrapgic)
        }
        this.ecaAreaLayer.addMany(this.ecaAreas)
        this.map.add(this.ecaAreaLayer)
      }
    },

    // 恢复路由点的缺省状态
    resetRoutePointShow () {
      if (!this.routePointsLayer) return
      const routeQuery = this.routePointsLayer.createQuery()
      const arr = this.$store.state.route.excRoutePoints
      this.routePointsLayer.queryFeatures(routeQuery).then((results) => {
        if (results.features.length > 0) {
          // 遍历所有路由点
          results.features.forEach((v) => {
            const index = arr.indexOf(v.attributes.ObjectID)
            // 缺省禁止经过的点，若标示是其他的
            if (index !== -1 && v.attributes.option != -1)
            // 在排除中
            { this.setRouteFeatureAttribute(v, -1) }

            // 标示为必须经过的路由点，改为允许经过
            if (v.attributes.option == 1) {
              this.setRouteFeatureAttribute(v, 0)
            }

            // 标示为禁止经过的，在排除表中不存在的，改为允许
            if (v.attributes.option == -1 && index == -1) {
              this.setRouteFeatureAttribute(v, 0)
            }
          })
        }
      })
    },

    resetRoutePointDefaultOption () {
      if (!this.routePointsLayer) return

      const routeQuery = this.routePointsLayer.createQuery()
      const arr = this.$store.state.estiDistance.excWayPointArr
      this.routePointsLayer.queryFeatures(routeQuery).then((results) => {
        if (results.features.length > 0) {
          // 遍历所有路由点
          results.features.forEach((v) => {
            if (arr.indexOf(v.attributes.ObjectID) !== -1) { this.setRouteFeatureAttribute(v, -1) } else { this.setRouteFeatureAttribute(v, 0) }
          })
        }
      })
    },

    makePortPointArr () {
      var featureArr = []
      var myPortPointArr = this.portPointArr.filter(ele => ele.isWayPoint !== true)
      for (var i = 0; i < myPortPointArr.length; i++) {
        var port = myPortPointArr[i]
        var feature = {
          geometry: {
            type: 'point',
            longitude: port.lon,
            latitude: port.lat
          },
          attributes: {
            portId: port.PortID,
            portName: port.PortName
          }
        }
        featureArr.push(feature)
      } // end for

      setTimeout(() => {
        const promise = this.portPointLayer.applyEdits({
          addFeatures: featureArr
        })
      }, 0)

      this.finishedMakePointArr = true
      var len = myPortPointArr.length
      try {
        this.mapView.goTo({
          center: [myPortPointArr[len - 1].lon, myPortPointArr[len - 1].lat],
          zoom: 4
        })
        // console.log('scale=' + this.mapView.scale);
      } catch (error) {

      }
    },

    // 移除港口图层
    resetPortLayer () {
      if (this.portPointLayer) {
        this.portPointLayer.queryFeatures().then((results) => {
          this.portPointLayer.applyEdits({
            deleteFeatures: results.features
          })
          this.portPointLayer.refresh()
        })
      }
    },

    makeTrack () {
      if (this.trackLayer && this.trackLines.length) {
        this.trackLayer.removeAll()
        this.trackLines = []
      }

      this.trackLayer &&
          esriLoader
            .loadModules(['esri/geometry/support/webMercatorUtils'])
            .then(([webMercatorUtils]) => {
              this.$store.state.estiDistance.routePaths.forEach(paths => {
                const path = []
                if (paths) {
                  for (let i = 0; i < paths.route.length; i++) {
                    const o1 = paths.route[i]
                    const p1 = webMercatorUtils.lngLatToXY(o1[0], o1[1])
                    path.push(p1)
                  }
                }
                const trackLine = new this.Graphic({
                  geometry: {
                    type: 'polyline',
                    paths: path,
                    spatialReference: { wkid: 102100 }
                  },
                  attributes: {
                    Distance: paths.distance,
                    idArr: paths.idArr
                  },
                  symbol: lineSymbol
                })
                this.trackLayer.add(trackLine)
                this.trackLines.push(trackLine)
              })

              this.$store.state.estiDistance.routeWithECA.forEach(paths => {
                const path = []
                for (let i = 0; i < paths.route.length; i++) {
                  const o1 = paths.route[i]
                  const p1 = webMercatorUtils.lngLatToXY(o1[0], o1[1])
                  path.push(p1)
                }
                const trackLine = new this.Graphic({
                  geometry: {
                    type: 'polyline',
                    paths: path,
                    spatialReference: { wkid: 102100 }
                  },
                  attributes: {
                    Distance: paths.distance,
                    idArr: paths.idArr
                  },
                  symbol: ecalineSymbol
                })
                this.trackLayer.add(trackLine)
                this.trackLines.push(trackLine)
              })

              if (this.portPointLayer && this.portPointLayer.loaded) {
                const portView = this.mapView.allLayerViews.items.find(item => {
                  return item.layer.id == 'port-layer'
                })
                setTimeout(
                  () => {
                    this.portPointLayer.queryExtent().then(results => {
                      if (results) {
                        this.mapView.goTo(results.extent.expand(1.7))
                      }
                    })
                  }, 500)

                /**
                !this.changeTurnShow && portView &&
                  setTimeout(
                      () => {
                          portView.queryExtent().then(results => {
                              if (results)
                                  this.mapView.goTo(results.extent.expand(1.1));
                          });
                      },
                      this.$store.state.estimating.editFlag == 2 ? 1500 : 20
                  ) **/
              }
              /**
              setTimeout(
                () => {
                  this.portPointLayer.queryExtent().then(results => {
                    if (results) {
                      console.log(results.extent);
                      this.mapView.goTo(results.extent.expand(1.7))
                    }
                  })
                }, 500) **/

              this.$store.commit('setFinishedTrack', true)
              this.$store.commit('setIsNeedCalAfterRebuild', false)
              this.$store.commit('setIsGettedDistanceForEsti', false)
              this.addProgressCount()
            })
            .catch(error => {
              console.log(error)
            })
    }, // end makeTrack2

    resetTrackLayer () {
      this.trackLayer && this.trackLayer.removeAll()
    }, // end resetTrackLayer

    onMove (event) {
      if (event.toolEventInfo && event.toolEventInfo.mover.attributes.id) {
        const toolType = event.toolEventInfo.type
        const mover = event.toolEventInfo.mover
        if (toolType === 'move') {
          setTimeout(() => {
            this.showDuringLine(mover)
          }, 20)
        } else if (toolType === 'move-stop') {
          this.removeAndSaveTrack(mover)
          this.sketchVM.complete()
        }
      }
    },

    // 显示转向点
    showTurning (data) {
      this.removeTurnGraphics()
      data.forEach(item => {
        if (item.wt !== '0') {
          const turnGraphic = new this.Graphic({
            geometry: {
              type: 'point',
              latitude: item.lat,
              longitude: item.lon,
              spatialReference: { wkid: 102100 }
            },
            attributes: {
              id: item.routeSeq
            },
            symbol: markerSymbol
          })
          this.turnGraphics.push(turnGraphic)
        }
      })
      this.turnPointsLayer.addMany(this.turnGraphics)

      esriLoader
        .loadModules(['esri/widgets/Sketch/SketchViewModel'])
        .then(([SketchViewModel]) => {
          this.sketchVM = new SketchViewModel({
            layer: this.turnPointsLayer,
            view: this.mapView
          })
          this.sketchVM.on('update', event => {
            this.onMove(event)
          })
        })
        .catch(err => console.log(err))
    },

    // 移除转向点图层
    removeTurnGraphics () {
      this.sketchVM && this.sketchVM.destroy()
      this.sketchVM = null
      this.mapView.graphics.remove(this.duringLine1)
      this.mapView.graphics.remove(this.duringLine2)
      this.duringLine1 = null
      this.duringLine2 = null
      this.turnPointsLayer && this.turnPointsLayer.removeAll()
      this.turnGraphics = []
    },

    // 拖拽中的航线
    showDuringLine (p) {
      this.mapView.graphics.removeAll()
      const ind = this.turnGraphics.findIndex(item => {
        return item.attributes.id == p.attributes.id
      })
      const index = this.turningPoints.findIndex(item => {
        return item.routeSeq == p.attributes.id
      })
      const symbol = {
        type: 'simple-line',
        color: [161, 68, 59, 1],
        width: 1.2,
        style: 'dash'
      }
      const point = [this.turnGraphics[ind].geometry.x, this.turnGraphics[ind].geometry.y]
      const point1 = ECAUtil.latLng2WebMercator(
        this.turningPoints[index - 1].lon,
        this.turningPoints[index - 1].lat
      )
      const point2 = ECAUtil.latLng2WebMercator(
        this.turningPoints[index + 1].lon,
        this.turningPoints[index + 1].lat
      )
      const trackLine = new this.Graphic({
        geometry: {
          type: 'polyline',
          paths: [point1, point],
          spatialReference: { wkid: 102100 }
        },
        symbol: symbol
      })
      const trackLine2 = new this.Graphic({
        geometry: {
          type: 'polyline',
          paths: [point, point2],
          spatialReference: { wkid: 102100 }
        },
        symbol: symbol
      })

      this.duringLine1 = trackLine
      this.duringLine2 = trackLine2
      this.mapView.graphics.addMany([trackLine, trackLine2])
    },

    // 移除与保存当前转向点相关的航线
    removeAndSaveTrack (p) {
      // this.$store.commit("changeRouteFlag", true);
      this.$store.commit('showTrackForEsti', false)
      const ele = this.turnGraphics.find(item => {
        return item.attributes.id == p.attributes.id
      })
      setTimeout(() => {
        this.$store.commit('updateRouteFromRawForEsti', {
          id: p.attributes.id,
          longitude: ele.geometry.longitude,
          latitude: ele.geometry.latitude
        })
        this.$store.dispatch('reBuildRoutesForEsti')
      }, 20)
    },

    // 添加转向点
    addTurnPoint (coordinate) {
      this.longitude = _.toNumber(coordinate.lon)
      this.latitude = _.toNumber(coordinate.lat)
      // this.$store.commit("changeRouteFlag", true);
      this.$store.commit('showTrackForEsti', false)
      this.trackLayer.removeAll()

      setTimeout(() => {
        this.$store.commit('addRouteFromRawForEsti', {
          id: this.turnId,
          lon: this.longitude,
          lat: this.latitude
        })
        this.$store.dispatch('reBuildRoutesForEsti')
      }, 20)

      setTimeout(() => {
        this.showTurning(this.turningPoints)
      }, 50)

      this.turningEditVisible && this.sketchVM && this.sketchVM.complete()
      this.turningEditVisible = false
    },

    // 修改转向点
    updateTurnPoint (coordinate) {
      this.longitude = _.toNumber(coordinate.lon)
      this.latitude = _.toNumber(coordinate.lat)

      // this.$store.commit("changeRouteFlag", true);
      this.$store.commit('showTrackForEsti', false)
      this.trackLayer.removeAll()

      setTimeout(() => {
        this.$store.commit('updateRouteFromRawForEsti', {
          id: this.turnId,
          longitude: this.longitude,
          latitude: this.latitude
        })
        this.$store.dispatch('reBuildRoutesForEsti')
        this.showTurning(this.turningPoints)
      }, 20)

      setTimeout(() => {
        this.showTurning(this.turningPoints)
      }, 50)

      this.turningEditVisible && this.sketchVM && this.sketchVM.complete()
      this.turningEditVisible = false
    },

    // 移除转向点
    removeTurnPoint () {
      this.turningEditVisible && this.sketchVM && this.sketchVM.complete()
      this.turningEditVisible = false
      // this.$store.commit("changeRouteFlag", true)
      this.$store.commit('showTrackForEsti', false)
      this.trackLayer.removeAll()

      setTimeout(() => {
        this.$store.commit('delRouteFromRawForEsti', {
          id: this.turnId
        })
        this.$store.dispatch('reBuildRoutesForEsti')
        this.showTurning(this.turningPoints)
      }, 20)
      setTimeout(() => {
        this.showTurning(this.turningPoints)
      }, 50)
    },

    // 判断地图元素是否加载完毕
    judgeMapLoaded () {
      return (
        this.map && this.mapView &&
          this.portPointLayer &&
          this.routePointsLayer &&
          this.turnPointsLayer &&
          this.trackLayer &&
          this.ecaAreaLayer &&
          this.ecaLineLayer
      )
    },

    cancelTurningEditMenu () {
      this.turningEditVisible = false
    },

    addProgressCount () {
      this.progressCount++
    }
  },

  created: function () {
    if (!this.mapView) {
      this.createMap()
    }
  }
}
</script>

<style scoped lang="scss">
  #mapConEstimating {
    position: absolute; top: 0; left: 0; bottom: 0; right: 0;

  }
</style>
